import React, { useState, useEffect } from "react";
import { Button, Box, Typography, Grid } from "@mui/material";
import MyPosts from "../Post/MyPosts";
import Header1 from "../Header/Header1";
import axios from "axios";
import MyRequests from "../Requests/MyRequests";
import AcceptedRequests from "../Requests/AcceptedRequests";
import RequestToUsers from "../Requests/RequestToUsers";
import RequestFromUsers from "../Requests/RequestFromUsers";
import RequestUserPlatform from "../RequestUser/RequestUserPlatform";
import MyPostsPlatform from "../Post/MyPostsPlatform";
import MyRequestsPlatform from "../Requests/MyRequestsPlatform";
import Vidya from "./Vidya";
import Saransh from "./Saransh";
import Guru from "./Guru";
import Anuvadak from "./Anuvadak";
import Drishti from "./Drishti";
import Drona from "./Drona";
import ProjectAISync from "./ProjectAISync";
import ComingSoon from "../Header/ComingSoon";


const API_URL = process.env.REACT_APP_API_URL;

function AISync({ userId, onLogout }) {
  const [activePage, setActivePage] = useState("vidya"); // Default active page
  const [searchResults, setSearchResults] = useState([]);
  const [isVerified, setIsVerified] = useState(false);

  const handleSearch = (result) => {
    setSearchResults(result);
  };


  const checkUserVerification = async () => {
    try {
      const response = await axios.get(`${API_URL}/get_verify_user/`, { params: { user_id: userId } });
      if (response.data.status === 'verified') {
        setIsVerified(true);
      } else {
        setIsVerified(false);
      }
    } catch (error) {
      console.error('Error verifying user:', error);
      setIsVerified(false);  // Default to not verified in case of an error
    }
  };

  useEffect(() => {
    checkUserVerification();
  }, [userId]);

  const renderContent = () => {
    switch (activePage) {
      case "vidya":
        return <Vidya userId={userId} searchResults={searchResults} onLogout={onLogout}/>;
      case "my-posts-platform":
        return <Guru userId={userId} searchResults={searchResults} onLogout={onLogout}/>;
      case "my-requests-platform":
        return <Saransh userId={userId} searchResults={searchResults} onLogout={onLogout}/>;
      case "request-user-platform":
        return <Anuvadak userId={userId} searchResults={searchResults} onLogout={onLogout}/>;
      case "pay":
        return <Drishti userId={userId} searchResults={searchResults} onLogout={onLogout}/>;
      case "drona":
        return <Drona userId={userId} searchResults={searchResults} onLogout={onLogout}/>;
      default:
        return <Typography variant="h4" color="#ecf0f1">Welcome</Typography>;
    }
  };

  return (
    <div>
    
      <Header1 userId={userId} page_name={activePage} onSearch={handleSearch} onLogout={onLogout} />
     

      <ComingSoon/>

    </div>
  );
}

export default AISync;
